import loadable from '@loadable/component'

export const PromoBox = loadable(() => import('./PromoBox'))
export type {
  PromoBoxProps,
  PromoBoxLinkProps,
  PromoBoxButtonProps
} from './PromoBox'
